export enum QueryKey {
	BenchmarkOptions = 'benchmark-options',
	CheckInBenchmark = 'check-in-benchmark',
	CheckInMonthlyAvg = 'check-in-monthly-avg',
	DirectReportRecognitionBenchmark = 'direct-report-recognition-benchmark',
	DirectReportsOverview = 'direct-reports-overview',
	ManagerCheckInSettings = 'manager-check-in-settings',
	ManagerRecognitionSummary = 'manager-recognition-summary',
	OneOnOneEngagement = 'one-on-one-engagement',
	OneOnOneEngagementBenchmark = 'one-on-one-engagement-benchmark',
	RecognitionReceivedBenchmark = 'recognition-received-benchmark',
	StrongerConnections = 'stronger-connections',
	TeamActivityTotals = 'team-activity-totals',
	TeamReportDirectReportsOverview = 'team-report-direct-reports-overview',
	TeamReportManagerDrillDown = 'team-report-manager-drill-down',
	TeamReportExtendedTeamPulse = 'team-report-extended-team-pulse',
	TeamReportExtendedTeamRecognition = 'team-report-extended-team-recognition',
	UserData = 'user-data',
}
